import { useMediaQuery } from '@mui/material';
import React, { useEffect, useRef } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';

import emptyImage from '../../../../assets/images/emptyImage.svg';
import { Util } from '../../../../common/util/util';
import { Icon } from '../../../../components';
import { useActions } from '../../../../hooks/useActions';
import { useSearch } from '../../../../hooks/useSearch';

import './LiveSearch.sass';

export interface LiveSearchPropsI {
  inputValue: string;
}
//Живой поиск. Форма
export const LiveSearch = ({ inputValue }: LiveSearchPropsI) => {
  const navigate = useNavigate();
  const { setShowMenu, setVisibleHistory, fetchSearch } = useActions();
  const { items, value } = useSearch(); //Список предложений по поиску

  const mobileScreen = useMediaQuery('(max-width:900px)'); //Максимальная ширина экрана. Возвращает - true

  const wrapperRef = useRef(null); //Отслеживаем клик вне
  const [searchParams, setSearchParams] = useSearchParams();
  const searchQuery = searchParams.get('q') || '';
  //Убираем выделение <mark>...</mark>
  const clearSuggestion = (str: string) => {
    const re1 = /<mark>/gi;
    const re2 = /<\/mark>/gi;
    let clear_suggestion = str.replace(re1, '').replace(re2, '');
    return clear_suggestion;
  };

  //Форматирует строку
  const formatSuggestion = (str: string, code: number): string => {
    let s: string = `(${code}) `;
    if (str.startsWith(s)) {
      return str.slice(s.length);
    } else {
      return str;
    }
  };
  //Клик вне или закрыть
  const onCloseLiveSearch = (type: 'items' | 'catalog', item: any) => {
    if (type === 'items') {
      if (item.slug) navigate(`/items/${encodeURIComponent(item.slug)}`);
      else navigate(`/404`);
    }
    if (type === 'catalog') {
      navigate(`/${item.catStr}/${encodeURIComponent(item.catObj.slug)}`);
    }
    if (mobileScreen) document.body.style.overflowY = 'visible';
    setShowMenu(false);
  };
  //Событие для запроса
  useEffect(() => {
    if (inputValue.length > 0) {
      fetchSearch({ value: inputValue });
      setVisibleHistory(false);
    }
  }, [value]);

  //Получить категории (7 шт)
  const getCategories = () => {
    interface retCatI {
      catStr: 'processes' | 'materials' | 'equipment';
      catObj: any;
    }

    let cat: retCatI[] = [];
    if (items != null) {
      if (items.processes?.length > 0)
        for (const it of items.processes)
          cat.push({
            catStr: 'processes',
            catObj: it,
          });
      if (items.materials?.length > 0)
        for (const it of items.materials)
          cat.push({
            catStr: 'materials',
            catObj: it,
          });
      if (items.equipments?.length > 0)
        for (const it of items.equipments)
          cat.push({
            catStr: 'equipment',
            catObj: it,
          });
    }

    //Обрезаем до 7
    if (cat.length > 7) cat.length = 7;

    return cat;
  };

  let categories = getCategories();
  let isShow: boolean =
    (items && items?.catalog_items && items?.catalog_items?.length > 0) ||
    categories.length > 0
      ? true
      : false;
  if (isShow) {
    if (!mobileScreen) {
      return (
        <div className="LiveSearch">
          <div className="LiveSearch__left">
            {items?.catalog_items?.map((item: any, index: number) => (
              <li
                key={"li_" + item.id}
                className="LiveSearch__left_item_link"
                onClick={() => onCloseLiveSearch('items', item)}
              >
                <div
                  className={`LiveSearch__left_item ${
                    index != 0 ? 'LiveSearch__left_item--interval' : ''
                  }`}
                  key={"div_"+item.id}
                >
                  <img src={item.img ? item.img : emptyImage} />
                  <div className="LiveSearch__left_item_details">
                    <div className="LiveSearch__left_item_details_code">
                      <span className="LiveSearch__left_item_details_code_text1">
                        Код товара:&nbsp;
                      </span>
                      <span className="LiveSearch__left_item_details_code_text2">
                        {item.id}
                      </span>
                    </div>
                    <span
                      className="LiveSearch__left_item_details_description"
                      dangerouslySetInnerHTML={{
                        __html: formatSuggestion(item.title, item.id),
                      }}
                    ></span>
                    <span className="LiveSearch__left_item_details_price">
                      {Util.convertKopecksToRub(item.price_kopecks)} ₽
                    </span>
                  </div>
                </div>
              </li>
            ))}
          </div>

          {categories.length > 0 && (
            <div className="LiveSearch__right">
              <span className="LiveSearch__right_caption">
                ИСКАТЬ В КАТЕГОРИИ:
              </span>
              {categories.map((item: any) => (
                <li
                  key={"li_cat_" + item.catObj.id}
                  className="LiveSearch__right_item_link"
                  onClick={() => onCloseLiveSearch('catalog', item)}
                >
                  <span
                    key={`${item.catObj.slug}-${item.catObj.id}`}
                    className="LiveSearch__right_item"
                    dangerouslySetInnerHTML={{ __html: item.catObj.title }}
                  ></span>
                </li>
              ))}
            </div>
          )}
        </div>
      );
    } else {
      return (
        <div className="LiveSearch mobile" ref={wrapperRef}>
          <div className="LiveSearch__left mobile">
            {items?.catalog_items?.map((item: any, index: number) => (
              <li key={"li_" + item.id}
                className="LiveSearch__left_item_link mobile"
                onClick={() => onCloseLiveSearch('items', item)}
              >
                <div
                  className={`LiveSearch__left_item mobile ${
                    index != 0 ? 'LiveSearch__left_item--interval mobile' : ''
                  }`}
                  key={"div_"+item.id}
                >
                  {/* <img src={item.img ? item.img : emptyImage} />*/}
                  <Icon variant="searchGray" />
                  <div className="LiveSearch__left_item_details mobile">
                    {/*<div className="LiveSearch__left_item_details_code mobile">
                      <span className="LiveSearch__left_item_details_code_text1 mobile">Код товара:&nbsp;</span>
                      <span className="LiveSearch__left_item_details_code_text2 mobile">{item.id}</span>
                    </div>*/}
                    <span
                      className="LiveSearch__left_item_details_description mobile"
                      dangerouslySetInnerHTML={{
                        __html: formatSuggestion(item.title, item.id),
                      }}
                    ></span>
                    {/*<span className="LiveSearch__left_item_details_price mobile">{Util.convertKopecksToRub(item.price_kopecks)} ₽</span>*/}
                  </div>
                </div>
              </li>
            ))}
          </div>

          {/*          {categories.length > 0 && (
            <div className="LiveSearch__right mobile">
              <span className="LiveSearch__right_caption mobile">ИСКАТЬ В КАТЕГОРИИ:</span>
              {categories.map((item: any) => (
                <Link to={`/${item.catStr}/${item.catObj.slug}`} className="LiveSearch__right_item_link mobile" onClick={closeClick}>
                  <span
                    key={`${item.catObj.slug}-${item.catObj.id}`}
                    className="LiveSearch__right_item mobile"
                    dangerouslySetInnerHTML={{ __html: item.catObj.title }}
                  ></span>
                </Link>
              ))}
            </div>
          )}*/}
        </div>
      );
    }
  } else {
    return null;
  }
};
